import './bootstrap';
import '../css/app.css';

import {createSSRApp, h, reactive} from 'vue';
import {createInertiaApp} from '@inertiajs/vue3';
import {resolvePageComponent} from 'laravel-vite-plugin/inertia-helpers';
import {ZiggyVue} from '../../vendor/tightenco/ziggy/dist/vue.m';
import {createI18n} from 'vue-i18n';
import {messages} from '@/i18n.js';
import VueTippy from 'vue-tippy';
import VuePapaParse from 'vue-papa-parse';
import {router} from '@inertiajs/vue3';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

const i18n = createI18n({
    legacy: false,
    locale: 'ru', // set locale
    fallbackLocale: 'ru',
    messages,
    warnHtmlMessage: false
});

(function (m, e, t, r, i, k, a) {
    console.log('script loaded');
    m[i] = m[i] || function () {
        (m[i].a = m[i].a || []).push(arguments);
    };
    m[i].l = 1 * new Date();
    for (var j = 0; j < document.scripts.length; j++) {
        if (document.scripts[j].src === r) {
            return;
        }
    }
    k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a);
})
(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

ym(87205311, "init", {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true
});

(function (m, e, t, r, i, k, a) {
    console.log('script loaded');
    m[i] = m[i] || function () {
        (m[i].a = m[i].a || []).push(arguments);
    };
    m[i].l = 1 * new Date();
    for (var j = 0; j < document.scripts.length; j++) {
        if (document.scripts[j].src === r) {
            return;
        }
    }
    k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a);
})
(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

ym(99984857, "init", {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true
});




createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({el, App, props, plugin}) {
        const globalState = reactive({
            openMainSideMenu: false
        });

        return createSSRApp({render: () => h(App, props)})
            // return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(i18n)
            .use(
                VueTippy,
                // optional
                {
                    hideOnClick: true,
                    maxWidth: 350,
                    directive: 'tippy', // => v-tippy
                    component: 'tippy', // => <tippy/>
                    componentSingleton: 'tippy-singleton', // => <tippy-singleton/>,
                    defaultProps: {
                        placement: 'top',
                        allowHTML: true,
                        touch: false
                    } // => Global default options * see all props
                }
            )
            .use(VuePapaParse)
            .use(ZiggyVue)
            .provide('globalState', globalState)
            .mount(el);
    },
    progress: {
        color: '#4B5563'
    }
});

// Track page visits on Inertia navigation
router.on('navigate', (event) => {
    if (window.ym) {
        try {
        
            const page = event.detail.page;
            const props = page.props;
        
            const metrikaParams = {
                referer: event.detail.page.url !== window.location.pathname ? event.detail.page.url : document.referrer,
                title: document.title
            };
    
            if (props.element && page.component.includes('Articles/ArticleShow')) {
                if (props.element.views) {
                    metrikaParams.viewCount = props.element.views;
                }
                
                if (props.text && props.text.duration) {
                    metrikaParams.readingTime = props.text.duration;
                }
            }
            
        
            ym(87205311, 'hit', window.location.pathname, metrikaParams);
            ym(99984857, 'hit', window.location.pathname, metrikaParams);
        } catch (error) {
            console.error('Error sending data to Yandex.Metrika:', error);
        }
    }
});
